import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import Button from "react-bootstrap/Button";

const PORTAL_API_URL = process.env.REACT_APP_STRIPE_PORTAL_API_URL;

const SubscriptionPortal = () => {
  const [loading, setLoading] = useState(false);

  // カスタマーポータルへ全画面遷移した後にブラウザの「戻る」で返ってくると、
  // bfcache（戻る/進むキャッシュ）が JS 状態ごと復元するため loading=true のまま
  // ボタンが「準備中...」で無効のまま固まる。bfcache 復元（pageshow.persisted）と
  // 非 bfcache の再表示（visibilitychange）の両方でリセットする。
  useEffect(() => {
    const reset = () => setLoading(false);
    const onPageShow = (e) => {
      if (e.persisted) reset();
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") reset();
    };
    window.addEventListener("pageshow", onPageShow);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("pageshow", onPageShow);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  const handleManagePlan = async () => {
    setLoading(true);
    try {
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();
      const currentOrigin = window.location.href;

      const response = await fetch(PORTAL_API_URL, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          return_url: currentOrigin
        })
      });

      const data = await response.json();

      if (data.url) {
        // 成功時は遷移するだけ。setLoading(false) は呼び出さない。
        window.location.href = data.url;
      } else {
        throw new Error("Portal URL not found");
      }
    } catch (error) {
      console.error("Portal error:", error);
      alert("エラーが発生しました。ログイン状態を確認してください。");
      // エラーが発生した時だけ、ボタンを元に戻して再試行可能にする
      setLoading(false);
    }
    // 【重要】finally ブロックを削除しました
  };

  return (
    <Button
      variant="primary"
      onClick={handleManagePlan}
      disabled={loading}
    >
      {loading ? "準備中..." : "サブスクリプションの管理・解約（カスタマーポータル）"}
    </Button>
  );
};

export default SubscriptionPortal;